import { render, staticRenderFns } from "./healthandsafetydetails.vue?vue&type=template&id=91591844"
import script from "./healthandsafetydetails.vue?vue&type=script&lang=js"
export * from "./healthandsafetydetails.vue?vue&type=script&lang=js"
import style0 from "./healthandsafetydetails.vue?vue&type=style&index=0&id=91591844&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports